import * as React from 'react';

function GuestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.068 7.363h-1.241V3.311A1.316 1.316 0 0 0 13.507 2h-3.014a1.317 1.317 0 0 0-1.32 1.311v4.052h-1.24A1.98 1.98 0 0 0 5.947 9.34v9.823a1.98 1.98 0 0 0 1.984 1.976h.225a.886.886 0 0 0 1.77 0h4.134a.886.886 0 0 0 1.771 0h.236a1.98 1.98 0 0 0 1.984-1.976V9.34a1.98 1.98 0 0 0-1.984-1.976M13.31 3.508v3.857h-2.62V3.508zm3.228 15.655a.47.47 0 0 1-.471.469H7.932a.47.47 0 0 1-.47-.469V9.34a.47.47 0 0 1 .47-.469h8.136a.47.47 0 0 1 .47.47z"
  }));
}

export { GuestIcon };
